import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchMenu = createAsyncThunk(
   'menu/fetchMenu',
   async (_, thunkAPI) => {
      try {
         const response = await API.get('/menu')
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchMenu', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (_, { getState }) => {
         const { menu } = getState()
         if (menu.status === 'loading' || menu.status === 'success') return false
      }
   }
)

const initialState = {
   links: [],
   status: 'init'
}

const menuSlice = createSlice({
   name: 'menu',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchMenu.pending, state => {
         state.links = []
         state.categories = []
         state.status = 'loading'
      })
      builder.addCase(fetchMenu.fulfilled, (state, action) => {
         state.links = action.payload
         state.status = 'success'
      })
      builder.addCase(fetchMenu.rejected, state => {
         state.links = []
         state.status = 'error'
      })
   }
})

export const menu = menuSlice.reducer
